import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RegistrationWizard, IAppProps } from "@/submitter_registration/wizard"

document.addEventListener("turbolinks:load", () => {
  startReactApp()
})

const startReactApp = () => {
  const node = document.getElementById("react_submitter_registration")
  if (!node) {
    throw new Error("react_submitter_registration node not found")
  }

  const existingRoot = node._reactRoot;
  if (existingRoot) {
    console.warn("Root already present and component mounted. Skipping re-mounting.");
    return
  }

  const props = JSON.parse(node.getAttribute("data-react-props") || "") as IAppProps
  console.debug("React Props:", props)

  const root = createRoot(node)
  node._reactRoot = root
  root.render(
    <StrictMode>
      <RegistrationWizard {...props} />
    </StrictMode>,
  )
}

(window as any)["DEBUG"] = {
  BREAK_CSRF: function () {
    const meta = document.querySelector('meta[name="csrf-token"]')
    if (!meta) {
      throw new Error("CSRF meta tag was not found, unable to change token")
    }
    meta.setAttribute("content", "invalid")
    return "CSRF meta tag has been set to invalid value"
  },
}
